<template>
	<v-btn
		class="mb-2"
		color="info"
		small
	>
		<v-icon class="ml-1">
			mdi-camera
		</v-icon>
		<span>בחירת תמונה</span>
	</v-btn>
</template>

<script>
export default {
	name: "MediaGalleryBtn",
};
</script>

<style scoped>

</style>
